import rptAxios from "./rptAxios";

// (manual submit via modal + auto-submit on timer expiry)
export const callRptExamEndApis = async (candidateTokenDetails) => {
  const proctoringEnabled =
    candidateTokenDetails?.configuration?.proctoringEnabled === true;
  const candidateInfoData = JSON.parse(sessionStorage.getItem("candidateInfo"));
  const rptCandidateId = candidateInfoData?.id || null;
  const rptExamId = candidateInfoData?.examid || null;

  if (!proctoringEnabled || !rptCandidateId || !rptExamId) return;

  await Promise.allSettled([
    rptAxios.post(`/candidates/update-exam-status`, {
      candidateid: rptCandidateId,
      examid: rptExamId,
      status: 3, // 3 = submitted/completed
    }),
    // candidates/update-exam-status
    // rptAxios.post(`/secondary-camera/deactivate/${rptCandidateId}`, {}),
    rptAxios.post(`/user-sessions/logout`, {
      userid: rptCandidateId,
      entitytype: "candidate",
    }),
  ]);
};
